module.exports = __webpack_public_path__ + "static/media/SmartSelect_20200214-111451_Photos.8d584422.png";